"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.1.5'] && _();
}
catch (e) { }
